<script>
  // import { mapState } from 'vuex'
  export default {
    name: 'CheckboxWithObj',
    props: ['form', 'placeholder', 'rules', 'field', 'label', 'maxlength', 'id', 'password', 'dense', 'color', 'objkey', 'value', 'ifTrue', 'ifFalse'],
    computed: {
      model: {
        get() {
          return this.$store.state[this.form][this.field][this.objkey]
        },
        set(v) {
          this.$store.dispatch(`${ this.form }/SET_FIELD_OBJ`, { obj: this.field, key: this.objkey, value: v })
        },
      },
    },
  }
</script>

<template>
  <v-checkbox
    class="py-0 my-0"
    v-model="model"
    :dense="dense"
    :id="id"
    :placeholder="placeholder"
    :rules="rules"
    outlined
    :label="label"
    :color="color"
    :value="value"
    :true-value="ifTrue"
    :false-value="ifFalse"
  />
</template>
